import { filter, isNumber, pipe, values } from 'remeda';

type EnumLike<V = string> = Record<string, V>;

// getEnumValues returns values of Enum which values are strings. It doesn't support numeric values for now.
export const getEnumValues = <T extends EnumLike>(enumObj: T) => Object.values(enumObj);

export const getEnumNumberValues = <T extends EnumLike<number | string>>(enumObj: T) =>
  pipe(enumObj, values, filter(isNumber));

// toEnum converts string to Enum's value if enum contains such value, otherwise it returns undefined
export const toEnum = <T extends EnumLike>(enumObj: T, value: string) => {
  return getEnumValues<T>(enumObj).includes(value) ? (value as T[keyof T]) : undefined;
};

export const toNumericEnum = <T extends EnumLike<number | string>>(
  enumObj: T,
  value: number,
) => {
  return getEnumNumberValues<T>(enumObj).includes(value) ? (value as T[keyof T]) : undefined;
};
